/**
 * Minimal logger for services. No-op in production so console stays clean.
 * Use for mock success/debug logs; keep console.error for real errors if needed.
 */
const isDev = typeof process !== 'undefined' && process.env.NODE_ENV !== 'production';

export const serviceLogger = {
  log: (...args) => (isDev ? console.log(...args) : undefined),
  warn: (...args) => (isDev ? console.warn(...args) : undefined),
  error: (...args) => console.error(...args),
};
